$(document).ready(function () {    
    $(".fancy-productImageSlider").fancybox({
        'padding': 0,
        'transitionIn': 'none',
        'transitionOut': 'none',
        'arrows': true,
        helpers: {
            media: true
        },
        beforeLoad: function () {
            (this.$thumb.context.href.indexOf("youtube") >= 0) ? this.type = "iframe" : this.type = this.type;
        },
        caption: function () {
            return getCaption(this);
        }
    });

    $(".catalogeProductImg > a").fancybox({
        caption: function () {
            return getCaption(this);
        }
    });
    
    var getCaption = function(element) {
        return element.find('img').attr('alt');
    };
});
